var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMicrophoneFill16 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M3.833 8.016v0A4.293 4.293 0 0 0 8.127 12.3h.407a4.3 4.3 0 0 0 4.3-4.3v0m-4.501 6.5V13"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m9.208 10.306 2.448 2.62a.75.75 0 0 0 1.096-1.025l-8.104-8.67a.75.75 0 0 0-1.096 1.024L5.45 6.284v1.384a2.805 2.805 0 0 0 3.759 2.638Zm-2.81-7.404 4.655 4.93q.005-.081.005-.164V5.005a2.805 2.805 0 0 0-4.66-2.103",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrophoneFill16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };